export const COORDINATOR = "coordinator";
export const ENCOUNTER = "encounter";
export const DEVELOPMENT = "development";
export const ELLIPSIS = "...";
export const DASH = "-";

export const MILIGRAM = "mg";
export const UNITS = {
  glucose: { mg: "mg/dL", mm: "mmol/L" },
  bloodPressure: { mmHg: "mmHg" },
  heartRate: { bpm: "bpm" },
  weight: { pounds: "lbs", kilograms: "kg" },
  activity: { steps: "steps" },
  sleep: { hours: "hrs" }
};

export const PAGE_REDIRECTION_TYPES = {
  bp: "bloodpressure",
  bgl: "bloodglucose",
  spo2: "oxygensaturation",
  hr: "heartrate",
  temp: "temperature",
  spir: "spirometry",
  wt: "weight",
  activity: "activity",
  sleep: "sleep"
};

export const READING_TYPES = {
  heartRate: {
    abbreviation: "hrt",
    display: "Heart Rate",
  },
  bloodPressure: {
    abbreviation: "bp",
    display: "Blood Pressure",
  },
  bloodGlucose: {
    abbreviation: "bgl",
    display: "Blood Glucose",
  },
  spirometry: {
    abbreviation: "spir",
    display: "Spirometry",
  },
  temperature: {
    abbreviation: "temp",
    display: "Temperature",
  },
  weight: { abbreviation: "wt", display: "Weight"},
  oxygenSaturation: {
    abbreviation: "spo2",
    display: "Oxygen Saturation",
  },
  respirationRate: {
    abbreviation: "rr",
    display: "Respiration Rate",
  },
  memberNote: { abbreviation: "mn" },
  activity: {
    abbreviation: "activity",
    display: "activity",
  },
  sleep: {
    abbreviation: "sleep",
    display: "Sleep",
  }
};

export interface ICRACK_COOKIE_TOKEN {
  coordinator: "coordinator";
  patient: "patient";
  provider: "provider";
}

export const CRACK_COOKIE_TOKEN_TYPES: ICRACK_COOKIE_TOKEN = {
  coordinator: "coordinator",
  patient: "patient",
  provider: "provider"
};
